import { applyInverseTransform as m } from "../../geometry-utils/core/index.js";
import { getPivot as f } from "../../geometry-utils/three/index12.js";
import { addOpeningOnClosestPoint as v } from "./index.js";
function P({ obj: o, type: n, pivot: i, size: t = [1, 2, 0.15], rvDataList: r = void 0, modulousId: e = void 0, isEntrance: p = void 0 }) {
  const d = m(f(i, o), o);
  return v({ obj: o, type: n, size: t, point: d, rvDataList: r, modulousId: e, isEntrance: p });
}
export {
  P as addOpeningOnPivot
};
//# sourceMappingURL=index2.js.map
